'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var experimentalNextjsAppSupport = require('@apollo/experimental-nextjs-app-support');
var makeClient = require('./makeClient.js');

function ApolloWrapperInternal({ children, options }) {
    return /*#__PURE__*/ jsxRuntime.jsx(experimentalNextjsAppSupport.ApolloNextAppProvider, {
        makeClient: ()=>makeClient(options),
        children: children
    });
}

module.exports = ApolloWrapperInternal;
